// extracted by mini-css-extract-plugin
export var cardHeader = "_do-0";
export var reorderHandle = "_do-3";
export var titleArea = "_do-1";
export var titleAreaWithHandle = "_do-2";